import './Icon_Expand_All.css';

function Icon_Expand_All() {
  return (
    
      <div className='expand-all-icon-container'>
          <svg viewBox="0 0 24 24" className="expand-all-icon-svg">
            <path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>
             </svg>
      </div>
            
  );
}

export default Icon_Expand_All;
